export default __webpack_public_path__ + "static/media/diamond-wheel.73e5ff4f.png";